module.exports = __webpack_public_path__ + "static/logo-7a275c31420909f65967affb0d408e84.png";